module.exports = __webpack_public_path__ + "img/recordBg.3a189ce7.png";